<template>
 <div class="main-search">
    <el-input size="mini" ref="input" :placeholder="placeholder" v-model="keyword" class="input" @keyup.enter.native="search" @focus="onFocus">
        <el-button slot="append"  v-if="!isPhone" @click="search"><span class="el-icon-search"></span></el-button>
    </el-input>
 </div>
</template>

<script type="text/javascript">
export default {
    components: {},
    props: {
        width: {
            type: Number,
            default: 1000
        },
        isList:{
            type: Boolean,
            default: false
        },
        isSearch: {
            type: Boolean,
            default: false
        },
        placeholder:{
            type: String,
            default: '搜索'
        },
        default:{
            type: String,
            default: ''
        }
    },
    data() {
        return {
            keyword: '',
            showButton: false
        }
    },
    methods: {
        setFocus() {
            this.$refs['input'].focus();
        },
        onFocus(a) {
            if(this.isPhone && !this.isSearch) {
                this.showButton = true;
                this.$router.push({
                    path:'/search',
                })
            }
        },
        search() {
            if(this.keyword != null && this.keyword != ''){
                if(this.isList) {
                    this.$emit('search', this.keyword)
                }
                else {
                    this.$router.push({
                        path:'/list?q=' + this.keyword,
                    });
                }
            }
        },
        clear() {
            this.keyword = '';
        }
    },
    computed: {
        isPhone() {
            return this.width < 450;
        }
    },
    created() {
    },
    mounted() {
        if(this.isSearch)
            this.setFocus();
    },
    watch: {
    }
}
</script>

<style type="text/css" scoped>

.main-search {
    display: inline-block;
    border-radius: 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Search/index.vue